import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import IsLoading from "./IsLoading";

export default function AuthLayout() {
  const [user, isLoading] = useAuthState(auth);

  if (isLoading) {
    return <IsLoading />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
